
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';
import ProductCard from '../../components/base/ProductCard';
import { updateSEO, seoData, getBaseURL } from '../../utils/seo';

export default function Line11Page() {
  useEffect(() => {
    updateSEO({
      ...seoData.line11,
      canonical: `${getBaseURL()}/line11`,
      ogTitle: seoData.line11.title,
      ogDescription: seoData.line11.description,
      ogImage: `${getBaseURL()}/og-image.jpg`
    });
  }, []);

  const [selectedFilter, setSelectedFilter] = useState('Todos');
  const [sortBy, setSortBy] = useState('Relevância');

  const filters = ['Todos', 'Camisas', 'Polos', 'Conjuntos', 'Calças', 'Acessórios'];
  const sortOptions = ['Relevância', 'Menor Preço', 'Maior Preço', 'Mais Novos'];

  const products = [
    {
      id: '1',
      image: 'https://public.readdy.ai/ai/img_res/84a516ba4036eb71ade1608d92dad507.jpg.1%20quality%20shirt%20premium%20fabric%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20high-end%20shirt%20with%20emerald%20green%20brand%20accents%2C%20superior%20craftsmanship&width=400&height=500&seq=dluxmen-line11-shirt-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Camisa Super Clone 1.1',
      price: 'R$ 199,90',
      originalPrice: 'R$ 299,90',
      isNew: true
    },
    {
      id: '2',
      image: 'https://readdy.ai/api/search-image?query=luxury%20super%20clone%201.1%20quality%20polo%20premium%20cotton%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20high-end%20polo%20with%20emerald%20green%20brand%20details%2C%20superior%20quality&width=400&height=500&seq=dluxmen-line11-polo-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Polo Super Clone 1.1',
      price: 'R$ 159,90',
      isNew: true
    },
    {
      id: '3',
      image: 'https://readdy.ai/api/search-image?query=luxury%20super%20clone%201.1%20quality%20complete%20set%20premium%20fabric%20with%20sophisticated%20styling%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20high-end%20outfit%20with%20emerald%20green%20brand%20accents%2C%20superior%20craftsmanship&width=400&height=500&seq=dluxmen-line11-set-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Conjunto Super Clone 1.1',
      price: 'R$ 399,90',
      originalPrice: 'R$ 549,90'
    },
    {
      id: '4',
      image: 'https://readdy.ai/api/search-image?query=luxury%20super%20clone%201.1%20quality%20pants%20premium%20fabric%20with%20sophisticated%20cut%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20high-end%20trousers%20with%20emerald%20green%20brand%20details%2C%20superior%20quality&width=400&height=500&seq=dluxmen-line11-pants-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Calça Super Clone 1.1',
      price: 'R$ 179,90'
    },
    {
      id: '5',
      image: 'https://readdy.ai/api/search-image?query=luxury%20super%20clone%201.1%20quality%20t-shirt%20premium%20cotton%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20high-end%20tee%20with%20emerald%20green%20brand%20accents%2C%20superior%20craftsmanship&width=400&height=500&seq=dluxmen-line11-tshirt-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Camiseta Super Clone 1.1',
      price: 'R$ 89,90',
      isNew: true
    },
    {
      id: '6',
      image: 'https://readdy.ai/api/search-image?query=luxury%20super%20clone%201.1%20quality%20blazer%20premium%20fabric%20with%20sophisticated%20tailoring%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20high-end%20blazer%20with%20emerald%20green%20brand%20details%2C%20superior%20quality&width=400&height=500&seq=dluxmen-line11-blazer-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Blazer Super Clone 1.1',
      price: 'R$ 449,90',
      originalPrice: 'R$ 599,90'
    },
    {
      id: '7',
      image: 'https://readdy.ai/api/search-image?query=luxury%20super%20clone%201.1%20quality%20shorts%20premium%20fabric%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20high-end%20shorts%20with%20emerald%20green%20brand%20accents%2C%20superior%20craftsmanship&width=400&height=500&seq=dluxmen-line11-shorts-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Bermuda Super Clone 1.1',
      price: 'R$ 129,90'
    },
    {
      id: '8',
      image: 'https://readdy.ai/api/search-image?query=luxury%20super%20clone%201.1%20quality%20hoodie%20premium%20fabric%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20high-end%20hoodie%20with%20emerald%20green%20brand%20details%2C%20superior%20quality&width=400&height=500&seq=dluxmen-line11-hoodie-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Moletom Super Clone 1.1',
      price: 'R$ 249,90',
      originalPrice: 'R$ 329,90'
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8', fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Page Header */}
      <section className="pt-24 pb-8" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <h1 
            className="text-5xl font-bold mb-4 max-md:text-3xl"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#0B0B0B'
            }}
          >
            Line 1.1
          </h1>
          <p 
            className="text-lg max-md:text-base"
            style={{ 
              color: '#C0C0C0',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            Linha Super Clone 1.1 - Qualidade premium com acabamento perfeito
          </p>
        </div>
      </section>

      {/* Quality Badge */}
      <section className="py-6" style={{ backgroundColor: '#0F3F2F' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="text-center">
            <h2 
              className="text-2xl font-bold text-white mb-2 max-md:text-xl"
              style={{ fontFamily: 'Cinzel Decorative, serif' }}
            >
              SUPER CLONE 1.1
            </h2>
            <p 
              className="text-white/80 max-md:text-sm"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Qualidade superior • Acabamento perfeito • Tecidos premium
            </p>
          </div>
        </div>
      </section>

      {/* Filters and Sort */}
      <section className="py-6 border-b" style={{ backgroundColor: '#F8F8F8', borderColor: '#C0C0C0' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0">
            {/* Filters */}
            <div className="flex items-center space-x-6 overflow-x-auto pb-2 max-md:space-x-4">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap pb-2 border-b-2 transition-all duration-200 ${
                    selectedFilter === filter 
                      ? 'border-green-800 text-green-800' 
                      : 'border-transparent text-gray-600 hover:text-green-800'
                  }`}
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {filter}
                </button>
              ))}
            </div>

            {/* Sort */}
            <div className="flex items-center space-x-2">
              <span 
                className="text-sm font-medium"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                Ordenar por:
              </span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="text-sm font-medium border-none bg-transparent focus:outline-none pr-8"
                style={{ 
                  color: '#0B0B0B',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                {sortOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-md:gap-4">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
                onClick={() => {
                  console.log('Produto clicado:', product.name);
                }}
              />
            ))}
          </div>

          {/* Load More */}
          <div className="text-center mt-12">
            <button
              className="px-8 py-3 font-semibold text-white rounded-lg transition-all duration-300 hover:bg-green-700"
              style={{ 
                backgroundColor: '#0F3F2F',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Carregar Mais Produtos
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
